// Open flyout
document.querySelectorAll(".flyout-out-open--trigger").forEach((trigger) => {
    trigger.addEventListener("click", function () {
        const targetId = this.getAttribute("data-flyout-item");
        const targetFlyout = document.getElementById(targetId);

        if (targetFlyout) {
            targetFlyout.classList.add("product-fly-out--active");
            document.querySelector(".product-fly-out__opacity").classList.add("product-fly-out__opacity--active");
        }
        // Disable scrolling
        document.body.style.overflow = "hidden";
    });
});

// Close flyout via "X" icon
document.querySelectorAll(".product-fly-out__icon").forEach((icon) => {
    icon.addEventListener("click", function () {
        const flyout = this.closest(".product-fly-out");
        if (flyout) {
            flyout.classList.remove("product-fly-out--active");
        }

        document.querySelector(".product-fly-out__opacity").classList.remove("product-fly-out__opacity--active");
        // Enable scrolling again
        document.body.style.overflow = "";
    });
});

// Close ALL flyouts when overlay is clicked
const overlay = document.querySelector(".product-fly-out__opacity");
if (overlay) {
    overlay.addEventListener("click", function () {
        document.querySelectorAll(".product-fly-out.product-fly-out--active").forEach((flyout) => {
            flyout.classList.remove("product-fly-out--active");
        });

        overlay.classList.remove("product-fly-out__opacity--active");
        // Enable scrolling again
        document.body.style.overflow = "";
    });
}
